import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AuthenticatedRoute = ({ children }) => {
    const { currentUser, token } = useSelector((state) => state.user);
    const isAuthenticated = !!token && !!currentUser;

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    if (currentUser.must_change_password) {
        return <Navigate to="/change-password-required" replace />;
    }

    // Allow access for all authenticated users (pending, approved, rejected)
    return children;
};

export default AuthenticatedRoute;
